var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDribbble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a9 9 0 0 0-9 9c0 4.93 4.18 9 9 9a9 9 0 0 0 0-18Zm-.85 1.96c1.2.69 2.3 1.65 3.14 2.68.66-.4 1.28-.87 1.82-1.42a7.17 7.17 0 0 0-4.96-1.26Zm-2.68.88A7.13 7.13 0 0 0 6.1 8.06a8.9 8.9 0 0 0 6.38.4 9.5 9.5 0 0 0-4-2.62Zm6.9 3.38c.25.45.46.92.65 1.4a9.97 9.97 0 0 1 2.91-.13 7.07 7.07 0 0 0-1.43-2.97c-.64.65-1.36 1.23-2.14 1.7Zm-10.1.55a7.19 7.19 0 0 0 2.53 7.94 10.85 10.85 0 0 1 6.38-6.55 8.8 8.8 0 0 0-.53-1.1c-2.7 1.04-5.77.93-8.39-.29Zm11.27 2.7c.33 1.7.26 3.48-.22 5.15a7.08 7.08 0 0 0 2.76-5.19 7.95 7.95 0 0 0-2.54.04ZM9.5 18.64c1.36.5 2.87.59 4.27.23A9.15 9.15 0 0 0 14.7 13a8.93 8.93 0 0 0-5.2 5.64Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbble);
export default __webpack_public_path__ + "static/media/dribbble.1e32ac99027d4b0f99749083e150237b.svg";
export { ForwardRef as ReactComponent };